import * as React from "react";
import { useContext, useState } from "react";
import { TabStripTab } from "@progress/kendo-react-layout";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { EditProjectContext } from "../../EditProjectContext";
import SpdrCard from "./SpdrCard";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import getSpdrsForList from "./GetSpdrsForList";
import { RouteEditTab } from "../../RouteEditTab";
import { ProjectState } from "../../../ViewModel/ProjectState";
import { CardType } from "../CardType";
import { ReadOnlyProps } from "../../ReadOnlyProps";

export const InboundTab = ({ isReadOnly }: ReadOnlyProps) => {
  const { project, routeEditTabSelected } = useContext(EditProjectContext);
  const spdrsForListView = getSpdrsForList(
    routeEditTabSelected,
    project.SpdrsOnThisProject,
    project.FTLRoutes
  );
  const [deletionAllowed, setDeletionAllowed] = useState<boolean>(true);

  const spdrsCount = project.SpdrsOnThisProject?.length || 0;
  return [
    <TabStripTab key="Inbound" title={`Inbound (${spdrsCount})`}>
      <div>
        <Droppable
          droppableId={CardType.spdr}
          key="1"
          type={CardType.dragCard}
          isDropDisabled
          ignoreContainerClipping
        >
          {(provided) => {
            return (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {spdrsForListView?.map((spdr: SpdrClientViewModel, index) => {
                  const key = `${spdr?.SupplierGsdb} ${spdr?.PlantGsdb} ${spdr.DockCode} ${spdr.UsedInFtlRoutes}`;
                  return (
                    <Draggable
                      key={spdr.SpdrId}
                      draggableId={spdr.SpdrId?.toString() ?? ""}
                      index={index}
                      isDragDisabled={
                        routeEditTabSelected === RouteEditTab.Ltl ||
                        project.State !== ProjectState.Sandbox ||
                        isReadOnly
                      }
                    >
                      {(innerProvided, snapshot) => {
                        return (
                          <div
                            ref={innerProvided.innerRef}
                            style={{
                              zIndex: "3",
                            }}
                            {...innerProvided.draggableProps}
                            {...innerProvided.dragHandleProps}
                          >
                            <SpdrCard
                              key={key}
                              spdr={spdr}
                              deletionAllowed={deletionAllowed}
                              setDeletionAllowed={setDeletionAllowed}
                              isReadOnly={isReadOnly}
                            />
                          </div>
                        );
                      }}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>

        {spdrsForListView?.length === 0 ? <i>No SPDRs added to Project</i> : <div />}
      </div>
    </TabStripTab>,
  ];
};
